<template>
  <div id="stindex" style="">
    <bdialog :config='bconfig'></bdialog>
    <div v-show='bltData.length > 0' class='gTopMg gBorder' id='stidBlt'>
      <label @click='clBltRow()'>【{{$t('app_pltfblt')}}】{{bltData.length>0? bltData[0].noticeName:''}}。{{$t('app_clviewdt')}}</label>
      <el-button @click='viewMoreBlt' type='text'>{{$t('app_viewmore')}}</el-button>
    </div>
    <div v-loading='loading1' class="gBorder gTopMg" style="padding:24px;background:none;">
      <div style="position:relative;">
        <div style="position:absolute;right:0;z-index:80;">
          <div style="display:inline-block;" id='lbBtnGrp'>
            <label v-for='item,index in lbBtnCls' :class="item.class" @click="gpBtnClick(index)">{{item.lb}}</label>
          </div>
          <div style="display:inline-block;">
            <!-- <el-input></el-input> -->
            <el-date-picker
              :clearable='false'
              @change='dateChange'
              v-model="rgDate"
              type="daterange"
              :placeholder="$t('app_daterange')">
            </el-date-picker>
          </div>
          <div style="display:inline-block;margin-left:8px;">
            <MechanismSelector style='width:100%;' :data="mechanismData" ></MechanismSelector>
          </div>
        </div>
        <el-tabs id='idtabs'  v-model="tabbar" @tab-click="barClick">
          <el-tab-pane :label="$t('app_olinepday')" name="day">
          </el-tab-pane>
        </el-tabs>
        <div id='siday' style="width:100%;height:400px;"></div>
      </div>
    </div>
    <div  class="gTopMg" style="background:none;overflow:hidden;width:100%;height:700px;">
      <div class='gBorder' name='header1' style="position:relative;width:100%;height: 99%;display:inline-block;">
        <terMap :hidest='true' style="height: 100%;overflow:hidden;border:none;"></terMap>
      </div>
    </div>

    <div v-loading='loading3' class="gBorder gTopMg" style="padding:24px;background:none;">
      <div name='header2' style="position:relative;">
        <div style="position:absolute;right:0;z-index:99;">
          <div style="display:inline-block;margin-left:8px;">
            <MechanismSelector style='width:100%;' :data="mechanismData2" ></MechanismSelector>
          </div>
        </div>
        <el-tabs id='idtabs'  v-model="tabpie" @tab-click="pieClick">
          <el-tab-pane :label="$t('terminal.details.system_version')" name="sys">
          </el-tab-pane>
          <el-tab-pane :label="$t('terminal.details.hard_version')" name="fm"></el-tab-pane>
		  <el-tab-pane :label="$t('terminal.details.launcher')" name="launch"></el-tab-pane>
        </el-tabs>
        <el-row style="background:none;">
          <el-col :span="12">
            <div id='siPie' style="width:100%;height:400px;"></div>
          </el-col>
          <el-col :span="12">
            <div id='siBarVt' class='gBorder' style="width:100%;height:400px;margin-top:10px;">
              <div style="padding:24px;">
                <p style="font-size: 16px;color: #48576A;">TOP10{{$t('app_statistic')}}</p>
                <div style="margin-top:16px;height:1px;width:100%;background:lightgray;"></div>
                <el-row v-for='(item,index) in sdata3' :key="index" style="margin-top:17px;">
                  <el-col :span="9">
                    <label>{{item.name}}</label>
                  </el-col>
                  <el-col :span="15">
                    <div :style="genProcess(item.value)"></div><label>&nbsp;{{item.value}}</label>
                  </el-col>
                  <el-col :span="0">
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>
<script>
  import $ from "jquery";
  // require('@/assets/js/china.js')
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import terMap from '@/components/terminal/map'
  import bdialog from '@/components/bulletin/bdialog'

  export default{
    data () {
      var that = this
      return {
        bconfig: '',
        bltData: [],
        rgDate: '',
        xArr: [],
        olArr: [],
        offArr: [],
        slArr: [],
        otArr: [],
        barType: '0',
        data1: '',
        mech1: '',
        sdate1: '',
        sdate2: '',
        loading1: false,
        loading2: false,
        loading3: false,
        mech3: '',
        data3: '',
        sdata3: [],
        pieTitle: this.$t('terminal.details.system_version'),
        resizeCt: 0,
        tabbar: 'day',
        tabpie: 'sys',
        tabmap: 'where',
        lbBtnCls: [
          {class: 'lb-btn-sl', lb: this.$t('app_yesterday')}, //
          {class: '', lb: this.$t('app_rc15d')},
          {class: '', lb: this.$t('app_rc30d')}
        ],
        lbBtnLastIndex: 0,
        ctBarDay: '',
        ctMap: '',
        ctPie: '',
        ctBarVt: '',
        mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.mech1 = value
            that.getDvcList()
          }
        },
        mechanismData1: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            // alert('sl2')
          }
        },
        mechanismData2: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.mech3 = value
            that.getSysList()
          }
        }
      }
    },
    components: {
      MechanismSelector,terMap,bdialog
    },
    computed: {

    },
    methods: {
      viewMoreBlt () {
        this.$router.push({path: '/bulletin'})
      },
      clBltRow () {
        // console.log(row)
        var row = this.bltData[0]
        this.bconfig = {
          type: 2,
          edit: false,
          vinfo: '',
          binfo: {
            title: row.noticeName,
            content: row.noticeInfo
          },
          callback: () => {
            // _this.getList()
          }
        }
      },
      genProcess (value) {
        var ps = (value/this.data3.total).toFixed(2)
        var st = 'float:left;display:inline-block;width:' + ps*100*0.7  + '' + '%;background:rgb(75,157,237);height:14px;'
        return st
      },
      getDvcList () {
        /// status 0today 1week 2month 3diy
        this.loading1 = true
        var mech = this.mech1?this.mech1:''
        var type = this.barType
        var beginDate = this.sdate1
        var endDate = this.sdate2
        this.$indexDvStCount(mech, type, beginDate, endDate, (res) => {
          this.loading1 = false
          if (res.status === 200) {
            this.data1 = res.data
            if (this.data1) {
              // var num = parseInt(this.data1.number)
              var xarr = this.data1.time
              this.xArr = xarr
              this.olArr = res.data.online
              this.offArr = res.data.offline
              this.slArr = res.data.sleep
              this.otArr = res.data.other
              this.initSec1()
            } else {
              this.xArr = []
              this.olArr = []
              this.offArr = []
              this.slArr = []
              this.otArr = []
              this.initSec1()
            }
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading1 = false
        })
      },
      getBulletin () {
        this.loading2 = true
        this.$bulletin(1, 10, '', (res) => {
          this.loading2 = false
          if (res.status === 200) {
            this.bltData = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading2 = false
        })
      },
      getSysList () {
        this.loading3 = true
        var mech = this.mech3?this.mech3:''
        var type = ''        
        switch (this.tabpie) {
          case 'sys':
            type = '0'
            break
          case 'fm':
            type = '1'
            break
          case 'launch':
            type = '2'
            break
        }
        this.$indexSysFmCount(mech, type, (res) => {
          this.loading3 = false
          if (res.status === 200) {
            this.data3 = res.data
            if (res.data.list.length > 10) {
              this.sdata3 = res.data.list.slice(0,10)
            } else {
              this.sdata3 = res.data.list
            }
            this.initSec3()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading3 = false
        })
      },
      barClick () {

      },
      dateChange (vl) {
        if (vl) {
          // console.log(vl.split(' - '))
          this.gpBtnClick(-1)
          this.barType = '3'
          var arr = vl.split(' - ')
          this.sdate1 = arr[0]
          this.sdate2 = arr[1]
          this.getDvcList()
        }  else {
        }
      },
      pieClick () {
        switch (this.tabpie) {
          case 'sys':
            this.pieTitle = this.$t('terminal.details.system_version')
            break
          case 'fm':
            this.pieTitle = this.$t('terminal.details.hard_version')
            break
          case 'launch':
            this.pieTitle = this.$t('terminal.details.launcher')
            break
        }
        this.getSysList()
      },
      clearChats () {
        if (this.ctBarDay) {
          this.ctBarDay.dispose()
        }
        if (this.ctPie) {
          this.ctPie.dispose()
        }
      },
      initSec1 () {
        if (this.ctBarDay) {
          this.ctBarDay.dispose()
          this.ctBarDay = ''
        }
        this.ctBarDay =  echarts.init(document.getElementById('siday'));

        var datas = [this.$t('app_active1'),this.$t('app_sleep'),this.$t('app_offline'),this.$t('app_unuse')]
        var slobj = {}
        slobj[datas[3]] = false

        var option = {
            tooltip : {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            legend: {
                x: 'right',
                data: datas,
                selected: slobj
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis : [
                {
                    type : 'category',//category
                    // data : ['0','', '2', 3,'4','5','6', '7', '8','9','10','11','12','13','14','15', '16', '17','18','19','20','21','22','23']
                    data : this.xArr
                }
            ],
            yAxis : [
                {
                    type : 'value'
                }
            ],
            series : [
                {
                    name: this.$t('app_active1'),
                    type:'bar',
                    color:'#2CC7FD',
                    stack: 'haha',
                    data: this.olArr,
                    // barWidth: 20

                },
                {
                    name: this.$t('app_sleep'),
                    type:'bar',
                    color:'#FFCB16',
                    stack: 'haha',
                    data: this.slArr,
                    // barWidth: 20
                },
                {
                    name: this.$t('app_offline'),
                    type:'bar',
                    color:'#FF2424',
                    stack: 'haha',
                    data: this.offArr,
                    // barWidth: 20
                },
                {
                    name: this.$t('app_unuse'),
                    type:'bar',
                    color:'#EAEAEA',
                    stack: 'haha',
                    data: this.otArr,
                    // barWidth: 20
                }
            ]
        };
        this.ctBarDay.setOption(option);
      },
      initSec2 () {
        if (this.ctMap) {
          this.ctMap.dispose()
          this.ctMap = ''
        }
        this.ctMap =  echarts.init(document.getElementById('siHm'));
        //////////
        var geoCoordMap = {
            "重庆金佛山国家级自然保护区":[107.159108,28.951313],
            "未知1":[117.159108,38.951313]
        }
        var convertData = function (data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
                var geoCoord = geoCoordMap[data[i].name];
                if (geoCoord) {
                    res.push(geoCoord.concat(data[i].value));
                }
            }
            return res;
        };

        var option = {
            backgroundColor: 'white',
            visualMap: {
                min: 0,
                max: 1,
                splitNumber: 10,
                inRange: {
                    color: ['blue','#eac736','#d94e5d']
                },
                textStyle: {
                    color: '#fff'
                }
            },
            geo: {
                map: 'china',
                label: {
                    emphasis: {
                        show: true
                    }
                },
                roam: true,
                itemStyle: {
                    normal: {
                        areaColor: '#EFF2F7',
                        borderColor: '#1D8CE0'
                    },
                    emphasis: {
                        areaColor: '#D3DCE6'
                    }
                }
            },
            series: [{
                name: 'AQI',
                type: 'heatmap',
                coordinateSystem: 'geo',
                data: convertData([
                    {name: "重庆金佛山国家级自然保护区", value: 0.2, cor: [0,1]},
                    {name: "未知1", value: 1, cor: [0,1]}
                ])
            }]
        };
        //////////
        this.ctMap.setOption(option);
      },
      initSec3 () {
        if (this.ctPie) {
          this.ctPie.dispose()
          this.ctPie = ''
        }
        this.ctPie =  echarts.init(document.getElementById('siPie'), 'macarons');
        var option = {
            title: {
                text: this.pieTitle,
                subtext: this.data3.total,
                left:'center',
                top:'40%',
                padding:[24,0],
                textStyle:{
                    color:'lightgray',
                    fontSize:14,
                    align:'center'
                },
                subtextStyle: {
                    fontSize: 20,
                    color: 'black',
                    align:'center'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: "{b} " + this.$t('app_nums') +" {c}",//{a} <br/>{b}: {c} ({d}%)

            },
            legend: {
                orient: 'vertical',
                x: 'center',
                data:[]
            },
            series: [
                {
                    // name:'访问来源',
                    type:'pie',
                    radius: ['40%', '55%'],
                    label: {
                        normal: {
                            // '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  '
                            formatter: '{per|{d}%}',
                            backgroundColor: '#eee',
                            borderColor: '#aaa',
                            borderWidth: 1,
                            borderRadius: 4,
                            rich: {
                                a: {
                                    color: '#999',
                                    lineHeight: 22,
                                    align: 'center'
                                },
                                hr: {
                                    borderColor: '#aaa',
                                    width: '100%',
                                    borderWidth: 0.5,
                                    height: 0
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 33
                                },
                                per: {
                                    color: '#eee',
                                    backgroundColor: '#334455',
                                    padding: [2, 4],
                                    borderRadius: 2
                                }
                            }
                        }
                    },
                    data: this.data3.list
                }
            ]
        };
        this.ctPie.setOption(option);
      },
      initSec31 () {
        if (this.ctBarVt) {
          this.ctBarVt.dispose()
          this.ctBarVt = ''
        }
        this.ctBarVt =  echarts.init(document.getElementById('siBarVt'));

        var option = {
          color: ['#3398DB'],
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'shadow'
              },
              formatter: "{b} <br> 合格率: {c}%"
          },
          grid: {
              left: '4%',
              right: '4%',
              bottom: '2%',
              containLabel: true
          },
          xAxis: {
              type: 'value'
          },
          yAxis: {
              type: 'category',
              data: ['湖北省', '湖南省', '河南省', '安徽省', '浙江省', '山东省', '广东省'],
              axisLabel: {
                  show: true,
                  interval: 0,
                  rotate: 0,
                  margin: 10,
                  inside: false,
                  textStyle: {
                      //color: '#fff',
                      fontWeight: '20'
                  }
              }
          },
          series: [{
              type: 'bar',
              label: {
                  normal: {
                      show: true,
                      // formatter: '{c}',
                      formatter: function(v) {
                          var val = v.data;
                          if (val == 0) {
                              return '';
                          }
                          return val;
                      },
                      color: '#fff'
                  }
              },
              data: [22, 33, 44, 55, 66, 77, 88]
          }]
        };

        this.ctBarVt.setOption(option);
      },
      gpBtnClick (index) {
        // process last
        if (this.lbBtnLastIndex>=0 && this.lbBtnLastIndex<this.lbBtnCls.length) {
          this.lbBtnCls[this.lbBtnLastIndex].class = ''
        }
        // illegal
        if (index<0 || index>=this.lbBtnCls.length) {

          return
        }

        this.rgDate = ''

        this.lbBtnCls[index].class = 'lb-btn-sl'
        this.lbBtnLastIndex = index
        switch (index) {
          case 0:
            // today
            this.barType = '0'
            break
          case 1:
            // week
            this.barType = '1'
            break
          case 2:
            // month
            this.barType = '2'
            break
        }
        this.getDvcList()
      },
      cmRqs () {
        // this.initSec1()
        this.getDvcList()
        setTimeout(() => {
          this.getSysList()
        }, 300);

      }
    },
    destroyed () {
      this.clearChats()
    },
    mounted () {

      this.cmRqs()

      this.getBulletin()

      var _this = this
      $(document).ready(function(){
        $(window).resize(function() {
          _this.resizeCt+=1
          setTimeout(() => {
            _this.resizeCt-=1
            if (_this.resizeCt <= 0) {
              _this.resizeCt = 0
              //
              _this.cmRqs()
            }
          }, 1000);
        })
      })

    }
  }
</script>
<style scoped>
  #stindex{
    min-width: 800px;
  }
  #bttt {
    height: 70px;
    border-bottom: 1px solid rgb(223,230,236);
    font-size: 16px;
    color: #48576A;
    /* font-family:PingFangSC-Semibold; */
    font-weight:600;
    line-height:70px;
  }
  .bltsub {
    width: calc(100% - 46px);
    margin-left: 22px;

  }
  .bifrow {
    height: 48px;
    line-height: 48px;
    font-size:14px;
    font-weight:400;
    color:rgba(72,87,106,1);
    border-bottom: 1px solid rgb(223,230,236);
    cursor: pointer;
  }
  .bifrow label {
    cursor: pointer;
  }
  .bifrow label:nth-child(2) {
    float: right;
  }
  #lbBtnGrp label{
    margin-right:15px;
    font-size: 16px;
    color: #8497AA;
    cursor: pointer;
  }
  .lb-btn-sl {
    color: #20A0FF !important;
  }


  #stidBlt {
    height: 52px;
    line-height: 52px;
    color: #48576A;
    font-size: 14px;
  }
  #stidBlt label {
    margin-left: 24px;
    cursor: pointer;
  }
  #stidBlt .el-button {
    float: right;
    margin-top: 9px;
    margin-right: 24px;
  }
  /*   .el-tabs__nav .el-tabs__active-bar */
</style>



// WEBPACK FOOTER //
// StIndex.vue?10ec96e3